<template>
    <v-select
    v-model="selDatas"
    :items="selItems"
    multiple
    persistent-hint
    outlined
    dense
    :menu-props="{ maxHeight: '200px', bottom: '100px' }"
    
>

    <template #selection="{ item, index }">
        <span v-if="index === 0">
            <span class="group_chip" :style="{ backgroundColor: generateColor(item) }">
                {{ item }}
            </span>    
            <template v-if="selDatas.length > 1">
                <span class="group_chip_more">
                    외 {{ selDatas.length - 1 }}개
                </span>
            </template>
        </span>
    </template>
</v-select>

  </template>
  <script>
export default {
name: 'AppSelect',
props: {
    datas: {
        type: Array,
        required: true
    },
    items: {
        type: Array,
        required: true
    },
},
    data () {
        return {

        }
    },
    computed: {
        selDatas:{
            get(){
                return this.datas;
            },
            set(newVal){
                return this.$emit('item-selected', newVal);
            }
        },
        selItems(){
            return this.items;
        },
        labelText(){
            return this.label;
        }
    },
    methods: {
        // generateColor(item) {
        //     const hashCode = s => {
        //         let h = 0;
        //         for (let i = 0; i < s.length; i++) {
        //             h = Math.imul(31, h) + s.charCodeAt(i) | 0;
        //         }
        //         return h;
        //     };
        //     const color = "#" + ((hashCode(item) & 0xFFFFFF) << 0).toString(16);
        //     return color;
        // }
        generateColor(group) {
            const hashCode = s => {
                let h = 0;
                for (let i = 0; i < s.length; i++) {
                    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
                }
                return h;
            };

            let hash = hashCode(group) + group.length * 123456 + group.charCodeAt(0) * 98765;
            let color = ((hash & 0xFFFFFF) << 0).toString(16);

            while (color.length < 6) {
                color = "0" + color;
            }

            return `#${color}`;
        },
    }
}
</script>

<style scoped>
.v-select__menu {
  top: unset !important; /* 기본적으로 적용되는 top 속성 제거 */
  bottom: 0; /* 메뉴를 input 아래로 내리기 위해 bottom에 0 설정 */
}
.group_chip{
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 6px;
}
.group_chip_more{
    font-size: 12px;
    color: #aaa;
}
</style>